import React from 'react';
import PropTypes from 'prop-types';
import { SelectField } from 'common/form/SelectField';
import { useInvoiceDisputeReasonOptions } from '../../hooks';

export const DisputeReasonFilter = ({
  onChange,
  value,
}) => {
  const disputeReasonOptions = useInvoiceDisputeReasonOptions();

  return (
    <SelectField
      label="Dispute Reason"
      labelClassName="tracking-normal"
      onChange={({ value: val }) => onChange(val)}
      options={disputeReasonOptions}
      value={value ?? ''}
      placeholder="Choose a dispute reason"
      clearable
    />
  );
};

DisputeReasonFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

DisputeReasonFilter.defaultProps = {
  value: undefined,
};
